import { Container, Row, Col, Card } from 'react-bootstrap';

const About = () => {
  return (
    <Container className="py-5">
      <Row className="justify-content-center mb-5">
        <Col lg={8} className="text-center">
          <h1 className="display-4 fw-bold mb-4">About Paperdate</h1>
          <p className="lead text-muted">
            Connecting hearts and creating meaningful relationships since 2024.
          </p>
        </Col>
      </Row>

      <Row className="mb-5">
        <Col lg={6} className="mb-4 mb-lg-0">
          <Card className="border-0 shadow-sm h-100">
            <Card.Body className="p-4">
              <h3 className="fw-bold mb-3">
                <i className="bi bi-heart-fill text-primary me-2"></i>
                Our Mission
              </h3>
              <p className="text-muted">
                At Paperdate, we believe that everyone deserves to find meaningful connections. 
                Our mission is to create a safe, authentic, and enjoyable platform where 
                singles can meet, connect, and build lasting relationships.
              </p>
              <p className="text-muted mb-0">
                We're committed to fostering genuine connections by prioritizing user safety, 
                promoting respectful interactions, and using thoughtful matching to help you 
                find compatible partners.
              </p>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={6}>
          <Card className="border-0 shadow-sm h-100">
            <Card.Body className="p-4">
              <h3 className="fw-bold mb-3">
                <i className="bi bi-shield-check text-primary me-2"></i>
                Our Values
              </h3>
              <ul className="text-muted list-unstyled">
                <li className="mb-2">
                  <strong>Authenticity:</strong> We encourage real profiles and genuine interactions.
                </li>
                <li className="mb-2">
                  <strong>Safety:</strong> Your security and privacy are our top priorities.
                </li>
                <li className="mb-2">
                  <strong>Respect:</strong> We foster a community built on mutual respect.
                </li>
                <li className="mb-0">
                  <strong>Inclusivity:</strong> Everyone is welcome to find love on Paperdate.
                </li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mb-5">
        <Col lg={12}>
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-4">
              <h3 className="fw-bold mb-3">
                <i className="bi bi-stars text-primary me-2"></i>
                Why Choose Paperdate?
              </h3>
              <Row>
                <Col md={4} className="mb-3 mb-md-0">
                  <h5 className="fw-bold">Verified Profiles</h5>
                  <p className="text-muted mb-0">
                    Our verification process ensures you're connecting with real people 
                    who are serious about finding meaningful relationships.
                  </p>
                </Col>
                <Col md={4} className="mb-3 mb-md-0">
                  <h5 className="fw-bold">Smart Matching</h5>
                  <p className="text-muted mb-0">
                    Our intelligent matching system considers your preferences, interests, 
                    and location to suggest compatible matches.
                  </p>
                </Col>
                <Col md={4}>
                  <h5 className="fw-bold">Safe Environment</h5>
                  <p className="text-muted mb-0">
                    We take safety seriously with robust moderation, blocking features, 
                    and privacy controls to keep you protected.
                  </p>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col lg={8} className="text-center">
          <h3 className="fw-bold mb-3">Join Our Community</h3>
          <p className="text-muted">
            Thousands of singles have already found meaningful connections on Paperdate. 
            Whether you're looking for friendship, romance, or a life partner, 
            we're here to help you on your journey.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default About;

